import LoadGroupDetails from "./LoadGroupDetails";

export default LoadGroupDetails;